/**
 * Which doctors the schedule query should ask for, as ids it can send.
 *
 * Day view and Month view ask different questions — "which doctors am I looking
 * at", which may have several answers, and "whose month is this", which can only
 * have one. They used to share a single piece of state, and the two controls
 * driving it disagreed about how many ids it could hold: the Filters dropdown
 * wrote a list, while the search input read only the first entry. Ticking three
 * doctors left the search box captioned with one of them while the board showed
 * all three, and picking anything in the box discarded the other two.
 *
 * Keeping them apart is the fix; this is where the current view chooses between
 * them. A caller that already scopes the list to one doctor — "My Appointments",
 * or a patient's own — overrides both.
 */
export const resolveDoctorScope = ({
  effectiveDoctorId,
  isMonthView,
  monthDoctorId,
  selectedDoctors = [],
}) => {
  if (effectiveDoctorId) return [effectiveDoctorId.toString()];

  if (isMonthView) return monthDoctorId ? [monthDoctorId.toString()] : [];

  return selectedDoctors.map((id) => id.toString());
};
